// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { DateTime } from 'luxon'

class Program extends React.Component {
	render() {
		const { data, timezone, isLiked } = this.props
		let className = 'program-item'
		let nextTime = DateTime.fromMillis(
			data.next_timestamp_gmt * 1000,
			{ zone: timezone }
		).toLocaleString( DateTime.TIME_SIMPLE )

		return (
			<Link to={ `/program/${ data.slug }` } className={ className }>
				<div className="-inner">
					<div className="-image">
						{ data.featured_image_index.url &&
							<img src={ data.featured_image_index.url } srcSet={ data.featured_image_index.srcset } alt={ data.featured_image_index.alt } />
						}
					</div>

					<div className="-info">
						<header>
							<h3>
								{ isLiked &&
									<span className="-like">
										<i className="icon-heart" aria-hidden="true" />
									</span>
								}

								<span dangerouslySetInnerHTML={ { __html: data.title } } />
							</h3>
						</header>
					</div>
				</div>
			</Link>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		timezone: state.schedule.timezone
	}
}

export default connect( mapStateToProps )( Program )
